export default __webpack_public_path__ + "static/media/Toyota.78d6534a.svg";